import { useSelector } from "react-redux";
import { ApplicationState } from "..";

export const useAutomaticActionReducer = () => useSelector((state: ApplicationState) => state.automaticAction);
